import * as React from 'react';

import { Button, Paper, Typography } from '@mui/material';
import { LineChart } from '@mui/x-charts/LineChart';
import { VisibilityIdentifier } from '@mui/x-charts/plugins';

export interface ReportLine {
  id: string;
  label: string;
  counts: number[];
}

interface ReportLineChartProps {
  title: string;
  testId: string;
  periodLabels: string[];
  lines: ReportLine[];
}

export function ReportLineChart({ title, testId, periodLabels, lines }: ReportLineChartProps) {
  const [hiddenItems, setHiddenItems] = React.useState<VisibilityIdentifier<'line'>[]>([]);

  const allHidden = lines.every(line => hiddenItems.some(item => item.seriesId === line.id));

  const toggleAll = () => setHiddenItems(
    allHidden ? [] : lines.map(line => ({ type: 'line', seriesId: line.id }))
  );

  return (
    <Paper data-testid={testId} sx={{ padding: 2, marginBottom: 2 }}>
      <Typography variant="h6">{title}</Typography>
      <Button size="small" onClick={toggleAll}>{allHidden ? 'Show all' : 'Hide all'}</Button>
      <LineChart
        height={300}
        grid={{ horizontal: true }}
        xAxis={[{ scaleType: 'point', data: periodLabels }]}
        yAxis={[{ min: 0, tickMinStep: 1 }]}
        series={lines.map(({ id, label, counts }) => ({
          id, label, data: counts, curve: 'catmullRom', showMark: true,
        }))}
        slotProps={{ legend: { toggleVisibilityOnClick: true } }}
        hiddenItems={hiddenItems}
        onHiddenItemsChange={setHiddenItems}
      />
    </Paper>
  );
}
